<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/deviceZAAList' }">
					<i class="el-icon-video-camera"></i> 设备管理
				</el-breadcrumb-item>
				<el-breadcrumb-item>添加设备</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="155px">
				<el-row>
					<el-col :span="24">
						<el-form-item :label="'所属幼儿园'" prop="saaGRID">
							<el-select v-model="ruleForm.saaGRID" clearable filterable :placeholder="'请选择幼儿园'" class="handle-select mr10" @change="SAAIchange">
								<el-option v-for="item in ruleForm.optionsSAAI" :key="item.SAAGRID" :label="item.SAANAME" :value="item.SAAGRID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'设备码'" prop="zaaDEVI">
							<el-input v-model="ruleForm.zaaDEVI" :placeholder="'请输入设备码'" maxlength="50"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'设备名称'" prop="zaaNAME">
							<el-input v-model="ruleForm.zaaNAME" :placeholder="'请输入设备名称'" maxlength="50"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback" :loading="btnLoading">返回</el-button>
								<el-button type="primary" @click="submitForm('ruleForm')" :loading="btnLoading">提交</el-button>
								<!-- :show-close="false" -->
								<el-dialog title="提示" :visible.sync="dialogVisible" width="50%" :before-close="goDeviceList" :close-on-click-modal="false">
									<span>设备绑定成功!是否继续绑定其他设备?</span>
									<span slot="footer" class="dialog-footer">
										<el-button @click="dialogVisible = false;goDeviceList()">确 定</el-button>
										<el-button type="primary" @click="dialogVisible=false;loadZAA()">继续添加</el-button>
									</span>
								</el-dialog>
								
							</el-form-item>
						</div>
					</el-col>
				</el-row>
				
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'addDeviceZAA',
		data() {
			
			//验证设备名称不能重复
			const validateNAME = (rule, value, callback) => {
				if (value.toString().length == 0) {
					callback(new Error('请输入设备名称')) //长度在1-20之间
				} else if (value.toString().length < 1 || value.toString().length > 50) {
					callback(new Error('请输入长度在1~50之间的字符')) //长度在1-20之间
				} else {
					this.checkZAADENM(value);
					if (this.isRepeatNAME == true) {
						callback(new Error(this.strRepeatNAME));
					} else {
						callback();
					}
				}
			}
			
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				dialogVisible: false,
				isRepeatSAAI: false,
				isRepeatDEVI: false,
				isRepeatNAME: false,
				strRepeatNAME: '',
				btnLoading: false,
				ruleForm: {
					
					saaGRID: '',
					optionsSAAI: [],//所属幼儿园
					
					zaaDEVI: '',
					zaaNAME: '',
					
				},
				rules: {
					saaGRID: [{
						required: true,
						message: '请选择幼儿园',
						trigger: ['blur', 'change']
					}],
					zaaDEVI: [{
						required: true,
						message: '请输入设备码',
						trigger: ['blur', 'change']
					}],
					zaaNAME: [{
						required: true,
						trigger: ['blur', 'change'],
						validator: validateNAME
					}]
					
				}
			};
		},
		created() {
			this.getSAAI(); //幼儿园
		},
		methods: {
			//要继续添加下一条设备信息吗
			loadZAA(){
				this.ruleForm.zaaDEVI=''
				this.ruleForm.zaaNAME=''
				this.ruleForm.saaGRID=''
				this.clearValidate('ruleForm'); 
				this.btnLoading = false;
			},
			clearValidate(formName) {
			    //this.$refs[formName].clearValidate();
			    this.$refs[formName].resetFields();
			},
			//获取幼儿园信息
			getSAAI() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcZAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon //web侧 登录邮箱
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.ruleForm.optionsSAAI = response.data.KKDT;
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取幼儿园请求失败', //请求失败
						type: 'error'
					});
			
				});
			},
			//验证此幼儿园下，设备名称是否重复
			checkZAADENM(value) {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcZAA.svc/CHECK_ZAADENM';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sGRID: self_shop.ruleForm.saaGRID,
						sNAME: self_shop.ruleForm.zaaNAME
					}
				)
				.then((response) => {
					//请求成功返回的数据
					if (response.data.KKSTR == "Y") {
						this.isRepeatNAME = true;
						this.strRepeatNAME = "该设备名称已存在";
					} else {
						this.isRepeatNAME = false;
						
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取设备请求失败', //请求失败
						type: 'error'
					});
				});
			},
			submitForm(formName){
				this.$refs[formName].validate((valid) => {
					if (valid) {
						const self = this;
						self.btnLoading = true;
						var postUrl = 'WCF/WEB/svcZAA.svc/ADD_ZAA';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
									sGRID: self.ruleForm.saaGRID,
									sDEVI: self.ruleForm.zaaDEVI,
									sNAME: self.ruleForm.zaaNAME
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;
								
								if (resStatus == "200") {
									if (resKKSTR.substring(0,1) == "Y") {
										//this.$message.success('添加视频成功'); // 添加视频成功
										setTimeout(() => {								 
										    this.dialogVisible = true;	 
										}, 4000);
									}
									else if(resKKSTR.substring(0,1) == "E"){
										this.$message({
											message: "此设备已绑定至[" + resKKSTR.split('_')[1].toString() + ":" + resKKSTR.split('_')[2].toString() + "]无法重复绑定", //请求失败
											type: 'error'
										});
										self.btnLoading = false;
									}
									else if(resKKSTR.substring(0,1) == "S"){
										this.$message({
											message: "没有操作该设备的权限,请联系硬件商",
											type: 'error'
										});
										self.btnLoading = false;
									}
									else{
										this.$message({
											message: '保存请求失败', //请求失败
											type: 'error'
										});
										self.btnLoading = false;
									}
								} 
								else
								{
									this.$message({
										message: '保存请求失败', //请求失败
										type: 'error'
									});
									self.btnLoading = false;
								}
							})
							.catch((error) => {
								this.$message({
									message: '请求失败', //请求失败
									type: 'error'
								});
								self.btnLoading = false;
							});
					}
					else {
						this.$message({
							message: '提交失败', //表单验证失败
							type: 'error'
						});
						self.btnLoading = false;
					}
				});
			},
			// 幼儿园选择事件
			SAAIchange() {
				console.log("---SAAIchange--" + this.ruleForm.saaGRID);
				if (typeof(this.ruleForm.saaGRID) !== 'undefined') {
					console.log(this.ruleForm.saaGRID);
					this.ruleForm.zaaNAME = '';
					this.ruleForm.zaaDEVI = '';
					//this.ruleForm.saaGRID = '';
					//this.STIDdisabled = false;
			
				} else {
					//this.STIDdisabled = true;
				}
			},
			goDeviceList() {
				this.$router.push('/deviceZAAList') // 跳转路由
				this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件 reload
			
				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "addDeviceZAA") {
						indexs = i;
						break;
					}
				}
				this.closeTags(indexs);
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);
				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "addDeviceZAA") {
						indexs = i;
						break;
					}
				}
				this.closeTags(indexs);
			}
			
			
			
			
			
			
			
			
			
			
		}
		
	}
</script>

<style scoped>
	.font {
		font-size: 14px;
	}

	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}

	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 5px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}

	.handle-select-y {
		width: 45%;
	}
</style>
